import type { RouteLocationAsRelative } from 'vue-router'

export class NavigationRedirectError extends Error {
  to: RouteLocationAsRelative

  constructor(message: string, to: RouteLocationAsRelative) {
    super(message)
    this.name = 'RedirectError'
    this.to = to
  }
}
export class NavigationToModalError extends Error {
  modal: string
  props: any

  constructor(message: string, modal: string, props: any) {
    super(message)
    this.name = 'NavigationErrorModal'
    this.modal = modal
    this.props = props
  }
}

export class Navigation404Error extends Error {
  to?: RouteLocationAsRelative

  constructor(message: string, to?: RouteLocationAsRelative) {
    super(message)
    this.name = 'Navigation404Error'
    this.to = to
  }
}
